<template>
    <div class="form-group vfg-form-group" :class="getFieldRowClasses(field)">
        <label v-if="fieldTypeHasLabel(field)" :for="getFieldID(field)" :class="field.labelClasses">
            <span v-html="getSettingValue(field.label)"></span>
            <span v-if='field.help' class="help">
				<i class="icon"></i>
				<div class="helpText" v-html='field.help'></div>
			</span>
        </label>

        <div class="field-wrap">
            <div class="input-group">
                <div class="input-group-prepend" v-if="field.textPrepend">
                    <span class="input-group-text">{{field.textPrepend}}</span>
                </div>
                <component ref="child"
                           :is="getFieldType(field)"
                           :vfg="vfg"
                           :disabled="fieldDisabled(field)"
                           :model="model"
                           :schema="field"
                           :formOptions="options"
                           @model-updated="onModelUpdated"
                           @validated="onFieldValidated"
                ></component>
                <div class="input-group-append" v-if="field.textAppend">
                    <span class="input-group-text">{{field.textAppend}}</span>
                </div>
            </div>
            <div v-if="buttonVisibility(field)" class="buttons">
                <button v-for="(btn, index) in field.buttons" @click="buttonClickHandler(btn, field, $event)"
                        :class="btn.classes" :key="index" v-text="btn.label" :type="getButtonType(btn)"></button>
            </div>
        </div>

        <div v-if="field.hint" class="hint" v-html="fieldHint(field)"></div>

        <div v-if="fieldErrors(field).length > 0" class="errors help-block">
            <span v-for="(error, index) in fieldErrors(field)" :key="index" v-html="error"></span>
        </div>
    </div>
</template>
<script>
    import {get as objGet, isNil, isFunction} from "lodash";
    import {slugifyFormID} from "vue-form-generator/src/utils/schema";
    import formMixin from "vue-form-generator/src/formMixin.js";
    import fieldComponents from "vue-form-generator/src/utils/fieldsLoader.js";
    import FormGroup from 'vue-form-generator/src/formGroup'

    export default {
        extends: FormGroup,
        mixins: [formMixin],
        methods: {
            getSettingValue(value) {
                return typeof value === 'function' ? value() : value;
            }
        }
    }

</script>
<style lang="scss">
    .vfg-form-group {
        .titan-select {
            .multiselect__tags {
                width: 100%;
            }
        }

        .titan-date-picker {
            width: 100%;
        }

        .titan-select,
        .custom-filed,
        .wrapper {
            display: flex;
            position: relative;
            -ms-flex: 1 1 auto;
            flex: 1 1 auto;
            width: 1% ! important;
            margin-bottom: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/core/Form/vfg/formGroup.vue